/**
 * @prettier
 */
import SkipToOperations from "./components/skip-to-operations"

const AccessibilityPlugin = () => ({
  components: {
    SkipToOperations,
  },
})

export default AccessibilityPlugin
